import {SlideTypeVo} from '../../common/shared/api/nicolas/vo/enums/SlideTypeVo.enum';
import {SlideType} from '../generated/types';

export function createSlideType(slide_type: SlideTypeVo): SlideType {
  return map[slide_type];
}

const map: {[key in SlideTypeVo]: SlideType} = {
  [SlideTypeVo.AudioBook]: SlideType.AudioBook,
  [SlideTypeVo.Comic]: SlideType.Comic,
  [SlideTypeVo.EPUB]: SlideType.Epub,
  [SlideTypeVo.None]: SlideType.None,
  [SlideTypeVo.Slide]: SlideType.Slide,
  [SlideTypeVo.TalkHumor]: SlideType.TalkHumor,
  [SlideTypeVo.TalkNovel]: SlideType.TalkNovel,
  [SlideTypeVo.VOD]: SlideType.Vod,
  [SlideTypeVo.VideoOnly]: SlideType.VideoOnly,
};
